import { Component, AfterViewInit, ViewChild, ElementRef, Inject, Renderer2, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'widget-dialog',
    template: `
        <h2 mat-dialog-title>
            Booking Widget
            <button mat-icon-button (click)="closeDialog()" style="float:right">
                <mat-icon>close</mat-icon>
            </button>
        </h2>
        <mat-dialog-content class="dialog-content">
            <iframe #iframe style="width:100%; height:100%; border:none;"></iframe>
        </mat-dialog-content>
	`,
    styles: [`
    .dialog-content {
      padding: 0;
      height: 100%;
      overflow: hidden;
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetDialogComponent implements AfterViewInit {
	@ViewChild('iframe',{ static: false }) iframe: ElementRef<HTMLIFrameElement>;
	
	constructor(public dialogRef: MatDialogRef<WidgetDialogComponent>,
				@Inject(MAT_DIALOG_DATA) public data: { snippet: string },
				private renderer: Renderer2) { }
	
	ngAfterViewInit(): void {
		const iframeEl = this.iframe.nativeElement;
		const iframeDoc = iframeEl.contentDocument || iframeEl.contentWindow.document;
		iframeDoc.open();
		iframeDoc.write(this.data.snippet);
		iframeDoc.close();
	}
	closeDialog(): void {
		this.dialogRef.close();
	}
}
